<template>
  <div class="yxtbiz-discuss-question">
    <div class="mb40" v-if="showHeader">
      <div class="yxtbiz-discuss-question__title">{{ detail.name }}</div>
      <div class="yxtbiz-discuss-question__subinfo">
        {{ $t('pc_biz_lbl_discuss_content').d('讨论说明') }}
      </div>
      <div class="yxtbiz-discuss-question__content">{{ detail.content }}</div>
    </div>
    <div class="yxtbiz-discuss-question__subtitle">
      <span>{{ $t('pc_biz_lbl_discuss_question').d('讨论问题') }}</span>
      <span class="complete-status" v-if="!isPreview"
        >{{ $t('pc_biz_ai_lbl_complete') }} {{ completeCount }}/{{
          discussPostList.length
        }}</span
      >
    </div>
    <div>
      <div class="yxtbiz-discuss-question__tab">
        <div
          v-for="(question, index) in discussPostList"
          :key="question.postId"
          class="yxtbiz-discuss-question__tab__item"
          :class="{
            'yxtbiz-discuss-question__tab__item--active': currentIndex === index
          }"
          @click="changeTab(index)"
        >
          <span>Q{{ index + 1 }}</span>
          <yxt-svg
            v-show="question.complete"
            v-if="showComplete"
            class="ml4"
            width="14px"
            height="14px"
            icon-class="message-success"
          />
        </div>
      </div>
      <div
        class="yxtbiz-discuss-question__detail"
        v-if="discussPostList[currentIndex]"
      >
        <div class="yxtbiz-discuss-question__detail__content">
          <pre>{{ discussPostList[currentIndex].title }}</pre>
        </div>
        <div v-if="discussPostList[currentIndex].attachmentList">
          <yxtbiz-attachment-list
            :list="discussPostList[currentIndex].attachmentList"
          />
        </div>
      </div>
      <div v-if="showSpeech" class="mt16">
        <discuss-speech
          v-if="currentQuestion && currentQuestion.postId"
          :boardId="boardId"
          :question-id="currentQuestion.postId"
          :target-code="targetCode"
          :allow-anonymous="Boolean(detail.anonymous)"
          :is-preview="isPreview"
          :discuss-target-id="discussTargetId"
          :speech-designated="speechOnlySelf"
          :speechUserId="userId"
        ></discuss-speech>
      </div>
    </div>
  </div>
</template>

<script>
import { getDiscussDetail } from 'yxt-biz-pc/packages/discuss-question/src/service';
import DiscussSpeech from 'yxt-biz-pc/packages/discuss-speech';
import { DISCUSS_TARGET_CODE_TYPES } from './enum';
export default {
  name: 'YxtbizDiscussQuestion',
  components: {
    DiscussSpeech
  },
  props: {
    boardId: {
      // 版块id
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    projectId: {
      type: String,
      required: true
    },
    targetCode: {
      // 学习来源 kng，o2o
      type: String,
      default: DISCUSS_TARGET_CODE_TYPES.O2O
    },
    targetId: {
      type: String
    },
    shouldTabChange: {
      type: Function,
      default: () => Promise.resolve()
    },
    showSpeech: {
      type: Boolean,
      default: false
    },
    speechOnlySelf: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    showComplete: {
      type: Boolean,
      default: true
    },
    syncUserProcess: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      detail: {},
      discussPostList: [],
      currentIndex: 0,
      preCompleteStatus: 0
    };
  },
  computed: {
    currentQuestion() {
      if (
        !this.discussPostList ||
        !this.discussPostList[this.currentIndex] ||
        !this.discussPostList[this.currentIndex].postId
      ) {
        return null;
      }
      return this.discussPostList[this.currentIndex];
    },
    discussTargetId() {
      if (this.targetCode === DISCUSS_TARGET_CODE_TYPES.O2O) {
        return this.projectId;
      } else if (this.targetCode === DISCUSS_TARGET_CODE_TYPES.KNG) {
        return this.targetId;
      } else {
        return this.projectId;
      }
    },
    completeCount() {
      return this.discussPostList.filter(item => item.complete).length;
    }
  },
  mounted() {
    this.getDiscuss();
  },
  methods: {
    getDiscuss(update = false) {
      const params = {
        boardId: this.boardId,
        userId: this.userId,
        projectId: this.projectId,
        targetCode: this.targetCode,
        targetId: this.targetId || this.projectId
      };
      if (!this.isAdmin) {
        params.syncUserProcess = this.syncUserProcess;
      }
      return new Promise((resolve, reject) => {
        getDiscussDetail(params, this.isAdmin)
          .then(result => {
            const { discussPostList } = result;
            this.detail = result;
            discussPostList.forEach(discuss => {
              if (discuss.attachmentList) {
                discuss.attachmentList = this.transformAttachment4Discuss(
                  discuss.attachmentList
                );
              }
            });
            this.discussPostList = discussPostList.sort((a, b) => a.index - b.index);
            if (!update) {
              this.$emit('on-question-change', this.discussPostList[0], result.complete);
              this.preCompleteStatus = result.complete;
            }
            resolve(result);
          })
          .catch(error => {
            reject(error);
            console.log(error);
          });
      });
    },
    transformAttachment4Discuss(attachmentList) {
      return attachmentList
        .sort((a, b) => a.orderIndex - b.orderIndex)
        .map(item => {
          return {
            fileId: item.fileId,
            name: item.fileName,
            fileType: this.transformFileType(item.fileType, true),
            fileSubType: item.fileSubType,
            url: item.fileUrl,
            viewUrl: item.fileType === 0 ? item.coverUrl : undefined,
            fileSize: item.fileSize,
            status: this.transformFileStatus(item.status)
          };
        });
    },
    transformFileType(type, revert) {
      // 1:视频, 2-附件, 3-音频 4-文档  0： 图片
      const types = {
        image: 0,
        video: 1,
        zip: 2,
        audio: 3,
        doc: 4
      };
      if (revert) {
        return Object.keys(types).find(key => types[key] === type);
      }
      return types[type];
    },
    transformFileStatus(status) {
      // 转码状态(0:失败,1:进行中,2:完成)
      // -1 未发起转码 0转码中 1转码成功 2转码失败
      if (status === 0) {
        return 2;
      }
      if (status === 1) {
        return 0;
      }
      if (status === 2) {
        return 1;
      }
    },
    changeTab(index) {
      this.shouldTabChange()
        .then(() => {
          this.currentIndex = index;
          this.$emit('on-question-change', this.discussPostList[index]);
        })
        .catch(() => {
          console.log('should not change the tab');
        });
    },
    update() {
      this.getDiscuss(true).then(result => {
        if (this.preCompleteStatus !== result.complete) {
          this.preCompleteStatus = result.complete;
          this.$emit('on-complete-change', !!result.complete);
        }
      });
    }
  }
};
</script>
